<template>
	<div class="md-layout">
		<div class="md-layout-item md-medium-size-100 md-size-100">
			<h4>{{translate(locale.editUser)}}</h4>
		</div>
		<div class="md-layout-item md-medium-size-100 md-size-100" v-if="!loaded">
			<md-card>
				<md-card-content>
					<loading />
				</md-card-content>
			</md-card>
		</div>

		<div class="md-layout-item md-medium-size-100 md-size-100" v-if="loaded">
			<md-card>
				<md-card-content>
					<div class="md-layout">
						<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
							<div class="md-layout">
								<div class="md-layout-item md-small-size-100 md-size-100 text-right">
									<span class="late">{{translate(locale.required)}}</span>
								</div>
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-50 md-size-25">
									<md-field>
										<label>{{translate(locale.moiId)}}</label>
										<md-input type="text" v-model="user.moi_id"></md-input>
									</md-field>
								</div>
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-50 md-size-25">
									<md-field>
										<label>{{translate(locale.govId)}}</label>
										<md-input type="text" v-model="user.gov_id"></md-input>
									</md-field>
								</div>
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-50 md-size-25">
									<md-field>
										<label>{{translate(locale.last_name_km)}} *</label>
										<md-input type="text" v-model="user.last_name_km"></md-input>
									</md-field>
								</div>
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-50 md-size-25">
									<md-field>
										<label>{{translate(locale.first_name_km)}} *</label>
										<md-input type="text" v-model="user.first_name_km"></md-input>
									</md-field>
								</div>
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-50 md-size-25">
									<md-field>
										<label>{{translate(locale.last_name_en)}} *</label>
										<md-input type="text" v-model="user.last_name_en"></md-input>
									</md-field>
								</div>
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-50 md-size-25">
									<md-field>
										<label>{{translate(locale.first_name_en)}} *</label>
										<md-input type="text" v-model="user.first_name_en"></md-input>
									</md-field>
								</div>
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-50 md-size-25">
									<md-field>
										<label>{{translate(locale.dob)}} (YYYY-MM-DD) *</label>
										<md-input type="text" v-model="user.dob"></md-input>
									</md-field>
								</div>
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-50 md-size-25">
									<md-field>
										<label>{{translate(locale.gender)}} *</label>
										<md-select :placeholder="translate(locale.gender) + ' *'" v-model="user.gender">
											<md-option value="M">{{translate(locale.male)}}</md-option>
											<md-option value="F">{{translate(locale.female)}}</md-option>
											<md-option value="O">{{translate(locale.genderOther)}}</md-option>
										</md-select>
									</md-field>
								</div>
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-50 md-size-25">
									<md-field>
										<label>{{translate(locale.email)}} *</label>
										<md-input type="text" v-model="user.email"></md-input>
									</md-field>
								</div>
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-50 md-size-25">
									<md-field>
										<label>{{translate(locale.phoneNumber)}} *</label>
										<md-input type="text" v-model="user.phone_number"></md-input>
									</md-field>
								</div>
							</div>
						</div>
						<div class="md-layout-item md-size-100 text-right">
							<span v-for="e in errors" style="color: red">* {{translate(e)}}<br></span>
						</div>
						<div
							class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 text-right">
							<md-button class="md-raised md-primary"
								@click="updateUser()">{{translate(locale.editUser)}}</md-button>
						</div>
					</div>

				</md-card-content>
			</md-card>
		</div>
	</div>

	</div>

</template>

<script>
	export default {
		created() {
			this.getUser();
		},
		data() {
			return {
				loaded: false,
				user: {
					moi_id: "",
					gov_id: "",
					first_name_km: "",
					last_name_km: "",
					first_name_en: "",
					last_name_en: "",
					dob: "",
					gender: "",
					phone_number: "",
					email: ""
				},
				errors: []
			}
		},
		methods: {
			getUser() {
				this.$http.get(this.config.api + "/admin/user/get/" + this.$route.params.hash).then(data => {
					this.user.moi_id = data.body.data.personal_code;
					this.user.gov_id = data.body.data.government_id;
					this.user.first_name_km = data.body.data.first_name_km;
					this.user.last_name_km = data.body.data.last_name_km;
					this.user.first_name_en = data.body.data.first_name_en;
					this.user.last_name_en = data.body.data.last_name_en;
					this.user.dob = data.body.data.dob;
					this.user.gender = data.body.data.gender;
					this.user.phone_number = data.body.data.phone_number;
					this.user.email = data.body.data.email;
					this.loaded = true;
				});
			},
			updateUser() {

				if (!this.checkValidation()) {
					return;
				}

				this.$http.post(this.config.api + "/admin/user/update", {
					hash: this.$route.params.hash,
					user: this.user
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "You have updated this user successfully.||អ្នកបានកែប្រែអ្នកប្រើប្រាស់បានដោយជោគជ័យ។",
							icon: 'check_circle',
							type: 'success'
						});

						this.$router.push("/users/detail/" + this.$route.params.hash);
					}
				})
			},
			checkValidation() {
				this.errors = [];

				if (String(this.user.first_name_km).length < 2 ||
					String(this.user.last_name_km).length < 2 ||
					String(this.user.first_name_en).length < 2 ||
					String(this.user.last_name_en).length < 2 ||
					String(this.user.dob).length < 2 ||
					String(this.user.gender).length < 1 ||
					String(this.user.phone_number).length < 2 ||
					String(this.user.email).length < 2 ||
					String(this.user.password).length < 2 ||
					String(this.user.confirm_password).length < 2
				) {
					this.errors.push("Please fill in all required fields.||សូមបំពេញព័ត៌មានដែលតម្រូវឱ្យបំពេញទាំងអស់។"); return false;
				}

				if(!this.config.isEmail(String(this.user.email))) this.errors.push("Email is invalid.||អុីម៉េលមិនត្រឹមត្រូវ។");
				if(!this.config.isPhoneValid(String(this.user.phone_number))) this.errors.push("Phone Number is invalid.||លេខទូរស័ព្ទមិនត្រឹមត្រូវ។");

				if (this.errors.length == 0) return true;
				else return false;
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/Users/Edit.vue